export enum AccountingPackages {
  xero = 'Xero',
  bexio = 'Bexio',
  sage = 'Sage',
  sage50 = 'Sage 50',
  sage200 = 'Sage 200',
}
